.iconWrapper {
  padding: 10px;
}

.noSelect {
  user-select: none;
}

.closeButton {
  float: right;
}

.noSelectOverflow {
  user-select: none;
  overflow: hidden;
}

.stepCounter {
  padding-right: 10px;
}
